module.exports = __webpack_public_path__ + "img/harmonyOS_bg3.3cc3984d.jpg";